import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../base/input.component';
import { AltNeu } from '../../core/types';
import { TypeaheadInputComponent } from './typeahead-input.component';

@Component({
    standalone: true,
    imports: [CommonModule, TypeaheadInputComponent],
    selector: 'wd-an-typeahead',
    templateUrl: 'alt-neu-typeahead-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class AltNeuTypeaheadInputComponent extends InputComponent<AltNeu<string>> {
	@Input() placement = 'bottom';
	@Input() tableName?: string;
	@Input() tableColumn?: string;
	@Input() acceptOtherValues = false;
	@Input() expandOnFocus = false;
	@Input() expandOnClick = true;
	@Input() from?: 'hardCoded' | 'dietmarsMdb';
	@Input() filter?: (v: string, idx?: number) => boolean;

	constructor() {
		super();
	}
}
